import React, { useEffect, useState, useMemo } from 'react';
import { data, useSearchParams } from 'react-router-dom';
import './ArtistProfiles.css';
import profileImg from "../Images/profile.svg"
import Patron_Navbar from '../Patron_Navbar';
import {faFacebookF,faInstagram } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { FaFilter } from "react-icons/fa";
import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import { makeAuthenticatedGETRequest } from '../../services/serverHelper';
import { patronProfilePoints } from '../../services/apis';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import {
  specialization,
  languages,
  ChargesPerPerformance,
  artInfo1,
  indian_cities,
} from "../../Data/artistProfile.js";
import PatronSidebar from '../PatronSidebar.jsx';

export default function ArtistProfiles() {

  const {accessToken} = useSelector((state)=>state.auth);
  const [art, setArt] = useState(undefined);
  const [indx, setIndx] = useState(null);
  const [searchParams, setSearchParams] = useSearchParams({});
  const [filteredProfiles, setFilteredProfiles] = useState([]);
  const itemsPerPage = 10;

  const currentPage = Number(searchParams.get('page')) || 1;
  
  const updateFilter = (key, value) => {
    // setSearchParams({ 
    //   ...Object.fromEntries(searchParams), // Keep existing params
    //   ...newParams                           // Add new ones
    // });

    const params = new URLSearchParams(searchParams);

    if (value) params.set(key, value);
    else params.delete(key);

    params.set('page', '1'); // reset here

    setSearchParams(params);
  };
  
  const updatePage = (increment) => {
    const params = new URLSearchParams(searchParams.toString());
    const current = Number(params.get('page')) || 1;
    const nextPage = current + increment;

    params.set('page', nextPage.toString());
    console.log("currentPage state:", currentPage);
    console.log("URL page:", searchParams.get('page'));
    setSearchParams(params);
  };

  const [profileData , setProfileData] = useState([]);

  const navigate = useNavigate();

  //Index for art form to get category
  const findIndx = (art)=>{
    setArt(art);
    updateFilter( 'art', art );
    const index = artInfo1.findIndex(item => item.art === art);
    setIndx(index);
  }
  // this is to fetch the application details 
  const fetchAllApplication = async()=>{
    const toastId = toast.loading('Loading...');
    try{

      const response = await makeAuthenticatedGETRequest(patronProfilePoints.FETCH_PATRON_ALL_ARTIST_API ,accessToken);
      console.log('res'  ,response);
      if(response.status === 'success'){
        setProfileData(response.data);
      }
      else{
        toast.error(response.message);
      }


    } catch(error){
      console.log(error);
      toast.error("something went wrong , please try again");
    }

    toast.dismiss(toastId);
  }

  const filteredData = useMemo(() => {
    if (!profileData) return [];

    // Extract params once inside the memo
    const params = {
      location: searchParams.get('location')?.toLowerCase(),
      specialization: searchParams.get('specialization')?.toLowerCase(),
      art: searchParams.get('art')?.toLowerCase(),
      category: searchParams.get('category')?.toLowerCase(),
      budget: searchParams.get('budget')?.toLowerCase(),
      language: searchParams.get('language')?.toLowerCase(),
    };

    // Helper inside the memo
    const matches = (field, param) => !param || field?.toLowerCase().includes(param);

    let filteredProfiles = profileData.filter(profile => {
      
      const matchLocation = !params.location || profile.address?.city?.toLowerCase().includes(params.location);
    
      const matchSpecialization = !params.specialization || profile.artInfo?.specialization?.toLowerCase().includes(params.specialization);
        
      const matchArt = !params.art || profile.artInfo?.artCategory?.some(a => a.toLowerCase().includes(params.art));
        
      const matchCategory = !params.category || profile.category?.toLowerCase().includes(params.category);
        
      const matchBudget = !params.budget || parseInt(profile.chargesPerPerformance) <= parseInt(params.budget);
        
      const matchLanguage = !params.language || profile.personalInfo?.languages?.some(lang => lang.toLowerCase().includes(params.language.toLowerCase()));

      // Only include if ALL active gates are true
      const result =  matchLocation && matchSpecialization && matchArt && matchCategory && matchBudget && matchLanguage;
      return result;    
    });;
    return(filteredProfiles);
  }, [
    profileData, 
    searchParams.toString() // Depend on the string representation of URL params
  ]);

  useEffect(()=>{
    fetchAllApplication();    
  //  searchParams.();

  },[])


  useEffect(() => {
    if(Array.from(searchParams.entries()).length > 0){
      setFilteredProfiles(filteredData);
    }
    else{
      setFilteredProfiles([]);
    }
  },[filteredData])

  

  const [showFiltersPopup, setShowFiltersPopup] = useState(false);

  const dataToPaginate = useMemo(() => {
    // Check if any filter is active
    const hasFilters = Array.from(searchParams.values()).some(Boolean);

    const data = hasFilters ? filteredData : profileData || [];

    return data;
  }, [filteredData, profileData, searchParams.toString()]);


  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    // const endIndex = startIndex + itemsPerPage;

    return dataToPaginate.slice(startIndex, startIndex + itemsPerPage);
  }, [dataToPaginate, currentPage]);


  const totalPages = Math.ceil(dataToPaginate.length / itemsPerPage);


  useEffect(() => {
    // const params = new URLSearchParams(searchParams);
    // params.set('page', 1);
    // setSearchParams(params);
  }, [searchParams.toString()]);

  const handleSubmit = (e)=>{
    e.preventDefault();
    setFilteredProfiles(filteredData);
    console.log(filteredData)
  }

  return (
    <>
      <Patron_Navbar />
      <div className='dashboard-layout'>
        <PatronSidebar />
        <div className='Patron-ArtistProfiles_Page'>
          <div className='Patron-ArtistProfiles_Image'>
            <div className='Patron-ArtistProfiles_Image_Content'>
              <p>Artist Profiles</p>
            </div>
          </div>
          <div className='Patron-ArtistProfiles_Main'>
            
            {/*  this is for filter part  */}
            <div style={{
                    height:"fit-content"
                  }} className='ArtistProfiles_Allfilters'>
              <h5 style={{textAlign:'center', display:'flex', alignItems:'center', gap:'5px', justifyContent:'center'}}>
                <FaFilter />
                All filters
              </h5>
              <div className='ArtistProfiles_Allfilters_form'>
                <form onSubmit={handleSubmit}>
                  <div className='ArtistProfiles_Allfilters_form_inputfield'>
                    <label>Art Specialization</label>
                    <select onChange={e=> updateFilter( 'specialization', e.target.value )}>
                      <option selected hidden>Select Specialization</option>
                      {
                        specialization.map((item, index)=>{
                          return(
                            <option key = {index} value = {item}>{item}</option>
                          )
                        })
                      }
                    </select>
                  </div>
                  <div className='ArtistProfiles_Allfilters_form_inputfield'>
                    <label>Art</label>
                    <select onChange={e=>findIndx(e.target.value)}>
                      <option selected hidden>Select Art</option>
                      {
                        artInfo1.map((item, index)=>{
                          return(
                            <option key={index} value={item.art}>{item.art}</option>
                          )
                        })
                      }
                    </select>
                  </div>
              
                  <div className='ArtistProfiles_Allfilters_form_inputfield'>
                    <label>Category</label>
                    <select onChange={e=> updateFilter('category', e.target.value )}>
                      <option selected hidden>Select Category</option>
                      {
                        artInfo1[indx]?.category.map((item, index)=>{
                          return(
                            <option key={index} value={item}>{item.type}</option>
                          )
                        })
                      }
                    </select>
                  </div>
                  <div className='ArtistProfiles_Allfilters_form_inputfield'>
                    <label>Location</label>
                    <input onChange={e=> updateFilter( 'location', e.target.value )} type='text' placeholder='Enter Location'>
                    </input>
                  </div>
                  <div className='ArtistProfiles_Allfilters_form_inputfield'>
                    <label>Language</label>
                    <select onChange={e=> updateFilter('language', e.target.value )}>
                      <option selected hidden>Select Language</option>
                      {
                        languages.map((item, index)=>{
                          return(
                            <option key={index} value={item}>{item}</option>
                          )
                        })
                      }
                    </select>
                  </div>

                  <div style={{display:'flex', gap:'10px', marginTop:'10px'}}>
                    <button style={{width: '50%', color:'#a40505'}} onClick={()=> setSearchParams({})}> Reset </button>
                    <button type='submit' className='filter_btn'>Apply Filters</button>
                  </div>

                </form> 
              </div>
            </div>            
              <div className='artistcards_container'>
                {
                  paginatedData.map((profile, index)=>{
                    return(
                      <div className='artistcard' key={index} style={index % 2 === 0 ? {borderRight: '1px solid rgba(0, 0, 0, 0.2)'} : {borderLeft: '1px solid rgba(0, 0, 0, 0.2)'}}>
                        <div className='card_left'>
                          
                          <div className='card_left_img'>
                            <img src={profileImg} alt='profile'></img>
                          </div>
                          <div className='card_left_content'>
                            <h4 style={{fontWeight: 'bold', fontSize: '20px'}}> {`${profile.personalInfo.firstName} ${profile.personalInfo.lastName}`} </h4>
                            <p style={{fontWeight: 'normal', fontSize: '12px', color:'#918d8d'}}>{profile.address.city || 'NA'}, {profile.address.state || 'NA'} </p>
                            <div className='card_left_content_sociallinks'>
                            </div>
                            <button style={{width:'100%', backgroundColor: '#ad2f3b', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: '5px'}} onClick={() => navigate(`/patron-invite-artist/${profile._id}`)}>
                              Invite
                            </button>
                          </div>
                        </div>
                        <div className='card_right'>
                          <h5 style={{fontWeight: 'bold', fontSize: '18px'}}>Art Forms:</h5>
                          <div className='card_right_artforms' style={{display: 'flex', gap:'5px', flexWrap:'wrap'}}>
                            {profile.artInfo.artCategory && profile.artInfo.artCategory.length > 0 ? (
                              profile.artInfo.artCategory.map((artForm, index) => (
                                  <span style={{fontWeight:'normal', fontSize:'12px', color:'#918d8d', border:'1px solid #ccc', padding:'5px 10px', borderRadius:'5px'}}>{artForm}</span>
                              ))
                            ) : (
                              <p>No art forms specified</p>
                            )} 
                          </div>  
                          <p style={{fontWeight: 'normal', fontSize: '15px', color:'#918d8d'}}>{profile.category}</p>

                        <button style={{width:'100%', alignSelf: 'flex-end', justifySelf: 'flex-end', textAlign: 'right', color:'#86a3ff'}} onClick={()=>navigate(`/PortfolioDisplay?id=${profile._id}`)} className='patron-view_profile_btn'>View Profile</button>
                        </div>


                      </div>
                    )
                  })}


                {
                    dataToPaginate.length > itemsPerPage &&(
                      <div className='pagination_controls'>
                        <button className='prev_btn' onClick={() => updatePage(-1)} disabled={currentPage === 1}>
                          Prev
                        </button>

                        <span className='page_span' style={{margin:'0 10px' }}>Page {currentPage} of {totalPages}</span>

                        <button className='next_btn' onClick={() => updatePage(1)} disabled={currentPage === totalPages}>
                          Next
                        </button>

                      </div>
                    )
                  }
                  

                  {
                    dataToPaginate.length === 0 && (
                      <div style={{width:'100%', height:'100%', textAlign:'center', fontSize:'16px', fontWeight:'bold', padding:'20px', color:'#918d8d'}}>
                        <p>No artists found.</p>
                      </div>
                    )
                  }
              </div>

              
            </div>

                
        </div>
      </div>
      
    </>
  );}
